const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['extensions/afrux-theme-base/forum/components/Footer'];